import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    ERP_SYSTEM,
    BANK_DETAILS,
    ANNUAL_TURNOVER,
    COMPANY_BRAND
} from "./constants/table-columns";
import CompanyDetailsForm from "./forms/company-details-form";
import CompanyBrandsForm from "./forms/company-brands-form";
import CompanyAnnualTurnoversForm from "./forms/company-annual-turnovers-form";
import CompanyBankingFacilitiesForm from "./forms/company-banking-facilities-form";
import CompanyErpsForm from "./forms/company-erps-form";
// import CompanySchemesDetails from "./forms/company-schemes";
import { Row, Col, Icon, List, Statistic, Button } from "antd";
import { STATE_STATUS } from "constants";
import {
    updateCompanyLosDetail,
    updateCompanyLosAnnualTurnovers,
    updateCompanyLosErps,
    updateCompanyLosBankingFacilities,
    fetchCompanyLosBrands,
    fetchCompanyLosAnnualTurnovers,
    fetchCompanyLosBankingFacilities,
    fetchCompanyLosErps,
    fetchCompanyLosDetail,
    updateCompanyLosSchemes,
    fetchCompanyLosSchemes,
    deleteBrands,
    deleteTurnovers,
    deleteErpDetails,
    deleteBankingFacility
} from "./actions/index";
import { OrderedMap } from "immutable";

class CompanyDetailsDisplay extends React.Component {
    state = {
        erpModal: false,
        selectedId: "",
        bankingLoading: false,
        bankingModal: false,
        turnoverloading: false,
        turnoverModal: false,
        brandLoading: false,
        brandModal: false,
    }
    componentDidMount() {
        if (!status || status === STATE_STATUS.UNFETCHED) {
            this.props.fetchCompanyLosDetail(this.props.companyId);
            this.props.fetchCompanyLosErps(this.props.companyId);
            this.props.fetchCompanyLosBrands(this.props.companyId);
            this.props.fetchCompanyLosBankingFacilities(this.props.companyId);
            this.props.fetchCompanyLosAnnualTurnovers(this.props.companyId);
            this.props.fetchCompanyLosSchemes(this.props.companyId);
        }
    }

    componentDidUpdate() {
        if(this.state.erpLoading && this.props.erpDetailsStatus === STATE_STATUS.UPDATED){
            this.setState({
                selectId: "",
                erpLoading: false,
                erpModal: false
            });
        }
        if(this.state.bankingLoading && this.props.bankingDetailsStatus === STATE_STATUS.UPDATED){
            this.setState({
                selectedId: "",
                bankingLoading: false,
                bankingModal: false
            });
        }
        if(this.state.turnoverloading && this.props.annualTurnoversStatus === STATE_STATUS.UPDATED){
            this.setState({
                selectedId: "",
                turnoverloading: false,
                turnoverModal: false
            });
        }
        if(this.state.brandLoading && this.props.brandDetailsStatus === STATE_STATUS.UPDATED){
            this.setState({
                selectedId: "",
                brandLoading: false,
                brandModal: false
            });
        }
    }

    onValuesSubmit = (type, values) => {
        let finalData = [];
        let initialData = [];
        switch(type) {
        case "DETAILS":
            this.props.updateCompanyLosDetail(this.props.companyId, values);
            break;
        case "TURNOVERS":
            initialData = this.props.annualTurnovers
                .filter(_ => _.id !== values.id).toJS()
                .map(_ => ({..._, anchor: _.anchor && _.anchor.id, financial_year: _.financial_year && _.financial_year.id}));
            finalData = [...initialData, values];
            this.props.updateCompanyLosAnnualTurnovers(this.props.companyId, finalData);
            this.setState({
                turnoverloading: true
            });
            break;
        case "ERPS":
            initialData = this.props.erpDetails.filter(_ => _.id !== values.id).toJS();
            finalData = [...initialData, values];
            finalData.map(_ => {
                if(!_.id){
                    delete _.id;
                } else {
                    delete _.anchor;
                }
            });
            this.props.updateCompanyLosErps(this.props.companyId, finalData);
            this.setState({
                erpLoading: true
            });
            break;
        case "BRANDS":
            initialData = this.props.brandDetails
                .filter(_ => _.id !== values.id).toJS()
                .map(_ => ({..._, channel_product: _.channel_product && _.channel_product.id}));
            finalData = [...initialData, values];
            this.props.updateCompanyLosBrands(this.props.companyId, finalData);
            this.setState({
                brandLoading: true
            });
            break;
        case "BANKS":
            initialData = this.props.bankingDetails.filter(_ => _.id !== values.id).toJS().map(_ => ({..._, bank: _.bank && _.bank.id}));
            finalData = [...initialData, values];
            this.props.updateCompanyLosBankingFacilities(this.props.companyId, finalData);
            this.setState({
                bankingLoading: true
            });
            break;
        case "SCHEMES":
            this.props.updateCompanyLosSchemes(this.props.companyId, values);
            break;
        default:
            break;
        }
    }
    getValues() {
        const valueMap = this.props.detail && this.props.detail.get("data");
        if (valueMap) {
            return valueMap.form;
        }
        return null;
    }

    getLoading() {
        const status = this.props.detail && this.props.detail.get("status");
        if (status === STATE_STATUS.FETCHING || status === STATE_STATUS.UPDATING) {
            return true;
        }
        return false;
    }
    getExtra() {
        const status = this.props.detail && this.props.detail.get("status");
        if (status === STATE_STATUS.UPDATING) {
            return (<div>Updating...<Icon type={"loading"} /></div>);
        }
        if (status === STATE_STATUS.FETCHING) {
            return (<div>Fetching...<Icon type={"loading"} /></div>);
        }
        if (status === STATE_STATUS.UPDATED) {
            return (<div>Updated <Icon type={"check-circle"} /></div>);
        }
        if (status === STATE_STATUS.UPDATE_FAILED) {
            return (<div>Update Failed<Icon type={"close"} /></div>);
        }
        if (status === STATE_STATUS.FETCH_FAILED) {
            return (<div> Fetch Failed <Icon type={"close"} /></div>);
        }
        return null;
    }

    deleteField = (id, recordName) => {
        switch(recordName) {
        case "companyBrand":
            this.props.deleteBrands(id, this.props.companyId);
            break;
        case "erpDetails":
            this.props.deleteErpDetails(id, this.props.companyId);
            break;
        case "annualTurnover":
            this.props.deleteTurnovers(id, this.props.companyId);
            break;
        case "bankingFacility":
            this.props.deleteBankingFacility(id, this.props.companyId);
            break;
        default:
            break;
        }
    }

    renderList = (dataSource, editAction, constant, recordName) => {
        return (
            <List
                className={"border-none no-shadow"}
                dataSource={dataSource || new List([])}
                renderItem={(_, k) => (
                    <List.Item                 
                        key={k}
                        className={
                            "border-none flex-column padless-card mt-10 schemes-detail p-10 bg-white"
                        }
                    >
                        <div 
                            className={"d-flex m-5 p-5 flex-row w-100 justify-content-space-between align-items-center"}
                            style={{
                                backgroundColor: "#fafafa"
                            }}
                        >
                            <Statistic 
                                valueStyle={{
                                    fontSize: "16px",
                                    fontWeight: 500
                                }}
                                className={"stat-title"}
                                title="ID" 
                                value={_.id} 
                            />
                            {this.props.company_details_edit_perm ? (
                                <div>
                                    <Icon 
                                        onClick={() => editAction(_.id)} 
                                        className={"cursor-pointer"} 
                                        style={{ padding: "10px", fontSize: "20px", background: "#fff", color: "#2D9CDB" }} 
                                        type={"edit"} 
                                        theme={"outlined"}
                                    />
                                    <Icon 
                                        onClick={() => this.deleteField(_.id, recordName)} 
                                        className={"cursor-pointer"} 
                                        style={{ padding: "10px", fontSize: "20px", background: "#fff", color: "#2D9CDB" }} 
                                        type={"delete"} 
                                        theme={"outlined"}
                                    />
                                </div>
                            ) : null}
                        </div>
                        <div className={"d-flex m-5 p-5 flex-row w-100 flex-wrap"}>
                            <Col className={"d-flex flex-row flex-wrap ml-05"} span={24}>
                                {constant.map((__, key) => (
                                    <Col span={6} className={"mt-10 mb-10"} key={k} >
                                        <Statistic 
                                            valueStyle={{
                                                fontSize: "16px",
                                                fontWeight: 600
                                            }} 
                                            title={__.label} 
                                            value={_[recordName][key]}
                                        />
                                    </Col>
                                )).toList()}
                            </Col>
                        </div> 
                    </List.Item>
                )}
            />
        );
    }

    toggleErpModal = () => {
        if(this.state.erpModal){
            this.setState({
                erpModal: !this.state.erpModal,
                selectedId: ""
            });
        } else {
            this.setState({
                erpModal: !this.state.erpModal,
            });
        }
    }

    selectId = _ => {
        this.setState({
            selectedId: _
        }, () => {
            this.toggleErpModal();
        });
    }

    toggleBankingModal = () => {
        if(this.state.bankingModal){
            this.setState({
                bankingModal: !this.state.bankingModal,
                selectedId: ""
            });
        } else {
            this.setState({
                bankingModal: !this.state.bankingModal,
            });
        }
    }

    selectBankingId = _ => {
        this.setState({
            selectedId: _
        }, () => {
            this.toggleBankingModal();
        });
    }

    toggleTurnOverModal = () => {
        if(this.state.turnoverModal){
            this.setState({
                turnoverModal: !this.state.turnoverModal,
                selectedId: ""
            });
        } else {
            this.setState({
                turnoverModal: !this.state.turnoverModal,
            });
        }
    }

    selectTurnOverId = _ => {
        this.setState({
            selectedId: _
        }, () => {
            this.toggleTurnOverModal();
        });
    }

    toggleBrandModal = () => {
        if(this.state.brandModal){
            this.setState({
                brandModal: !this.state.brandModal,
                selectedId: ""
            });
        } else {
            this.setState({
                brandModal: !this.state.brandModal,
            });
        }
    }

    selectBrandId = _ => {
        this.setState({
            selectedId: _
        }, () => {
            this.toggleBrandModal();
        });
    }
    
    renderAction = (heading, action) => {
        return (
            <div className={"d-flex justify-content-space-between align-items-center"}>
                <h3>{heading}</h3>
                {this.props.company_details_edit_perm ? (
                    <Button onClick={action} type="primary">Add</Button>
                ) : null}
            </div>
        );
    }
    
    render() {
        return (
            <Row>
                <Col span={18} offset={3} className={"p-5"}>
                    <CompanyDetailsForm
                        values={this.props.companyDetails}
                        applicants={this.props.applicants}
                        onValuesSubmit={this.onValuesSubmit.bind(null, "DETAILS")}
                        loading={this.getLoading()}
                        disabledFields={!this.props.company_details_edit_perm}
                    />
                </Col>
                <Col span={18} offset={3} className={"p-5"}>
                    {this.renderAction("ERP Systems", this.toggleErpModal)}
                    {this.renderList(this.props.erpDetails, this.selectId, ERP_SYSTEM, "erpDetails")}
                    {this.state.erpModal && <CompanyErpsForm
                        toggleErpModal={this.toggleErpModal}
                        visible={this.state.erpModal}
                        values={new OrderedMap((this.props.erpDetails || []).find(_ => _.id === this.state.selectedId) || {})}
                        onValuesSubmit={this.onValuesSubmit.bind(null, "ERPS")}
                        loading={this.state.erpLoading}
                    />}
                </Col>
                <Col span={18} offset={3} className={"p-5"}>
                    {this.renderAction("Company Banking Facilities", this.toggleBankingModal)}
                    {this.renderList(this.props.bankingDetails, this.selectBankingId, BANK_DETAILS, "bankingFacility")}
                    {this.state.bankingModal && <CompanyBankingFacilitiesForm
                        values={new OrderedMap((this.props.bankingDetails || []).find(_ => _.id === this.state.selectedId) || {})}
                        onValuesSubmit={this.onValuesSubmit.bind(null, "BANKS")}
                        loading={this.state.bankingLoading}
                        toggleBankingModal={this.toggleBankingModal}
                        visible={this.state.bankingModal}
                    />}
                </Col>
                <Col span={18} offset={3} className={"p-5"}>
                    {this.renderAction("Company Brands", this.toggleBrandModal)}
                    {this.renderList(this.props.brandDetails, this.selectBrandId, COMPANY_BRAND, "companyBrand")}
                    {this.state.brandModal && <CompanyBrandsForm
                        values={new OrderedMap((this.props.brandDetails || []).find(_ => _.id === this.state.selectedId) || {})}
                        onValuesSubmit={this.onValuesSubmit.bind(null, "BRANDS")}
                        loading={this.state.brandLoading}
                        toggleBrandModal={this.toggleBrandModal}
                        visible={this.state.brandModal}
                    />}
                </Col>
                <Col span={18} offset={3} className={"p-5"}>
                    {this.renderAction("Annual Turnovers", this.toggleTurnOverModal)}
                    {this.renderList(this.props.annualTurnovers, this.selectTurnOverId, ANNUAL_TURNOVER, "annualTurnover")}
                    {this.state.turnoverModal && <CompanyAnnualTurnoversForm
                        values={new OrderedMap((this.props.annualTurnovers || []).find(_ => _.id === this.state.selectedId) || {})}
                        onValuesSubmit={this.onValuesSubmit.bind(null, "TURNOVERS")}
                        loading={this.state.turnoverloading}
                        visible={this.state.turnoverModal}
                        toggleTurnOverModal={this.toggleTurnOverModal}
                    />}
                </Col>
            </Row>
        );
    }
}

CompanyDetailsDisplay.propTypes = {
    location: PropTypes.object,
    detail: PropTypes.object,
    history: PropTypes.object,
    companyId: PropTypes.string,
    fetchCompanyLosDetail: PropTypes.func,
    updateCompanyLosDetail: PropTypes.func,
    fetchCompanyLosErps: PropTypes.func,
    updateCompanyLosErps: PropTypes.func,
    fetchCompanyLosAnnualTurnovers: PropTypes.func,
    updateCompanyLosAnnualTurnovers: PropTypes.func,
    fetchCompanyLosBankingFacilities: PropTypes.func,
    updateCompanyLosBankingFacilities: PropTypes.func,
    fetchCompanyLosBrands: PropTypes.func,
    updateCompanyLosBrands: PropTypes.func,
    applicants: PropTypes.object,
    companyDetails: PropTypes.object,
    erpDetails: PropTypes.array,
    brandDetails: PropTypes.array,
    bankingDetails: PropTypes.array,
    annualTurnovers: PropTypes.array,
    updateCompanyLosSchemes: PropTypes.func,
    schemeDetails: PropTypes.array,
    fetchCompanyLosSchemes: PropTypes.func,
    erpDetailsStatus: PropTypes.string,
    bankingDetailsStatus: PropTypes.string,
    annualTurnoversStatus: PropTypes.string,
    brandDetailsStatus: PropTypes.string,
    deleteBrands: PropTypes.func,
    deleteTurnovers: PropTypes.func,
    deleteErpDetails: PropTypes.func,
    deleteBankingFacility: PropTypes.func,
    company_details_edit_perm: PropTypes.bool 
};

CompanyDetailsDisplay.defaultProps = {
    company_details_edit_perm: false
};

const mapStateToProps = (state, props) => ({
    applicants: state.companyLosProfiles.getIn(["profiles", props.companyId, "data", "associates"]),
    companyDetails: state.companyLosProfiles.getIn(["details", props.companyId, "data"]),
    erpDetails: state.companyLosProfiles.getIn(["erps", props.companyId, "data"], []),
    erpDetailsStatus: state.companyLosProfiles.getIn(["erps", props.companyId, "status"]),
    brandDetails: state.companyLosProfiles.getIn(["brands", props.companyId, "data"], []),
    brandDetailsStatus: state.companyLosProfiles.getIn(["brands", props.companyId, "status"]),
    bankingDetails: state.companyLosProfiles.getIn(["bankingFacilities", props.companyId, "data"], []),
    bankingDetailsStatus: state.companyLosProfiles.getIn(["bankingFacilities", props.companyId, "status"]),
    annualTurnovers: state.companyLosProfiles.getIn(["annualTurnovers", props.companyId, "data"], []),
    annualTurnoversStatus: state.companyLosProfiles.getIn(["annualTurnovers", props.companyId, "status"]),
    schemeDetails: state.companyLosProfiles.getIn(["schemes", props.companyId, "data"]),
    company_details_edit_perm: state.user.getIn(["permissions", "company_details_edit"]) 
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        updateCompanyLosDetail,
        updateCompanyLosAnnualTurnovers,
        updateCompanyLosErps,
        updateCompanyLosBankingFacilities,
        fetchCompanyLosBrands,
        fetchCompanyLosAnnualTurnovers,
        fetchCompanyLosBankingFacilities,
        fetchCompanyLosErps,
        fetchCompanyLosDetail,
        updateCompanyLosSchemes,
        fetchCompanyLosSchemes,
        deleteBrands,
        deleteTurnovers,
        deleteErpDetails,
        deleteBankingFacility
    }, 
    dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CompanyDetailsDisplay);